import { NOT_FOUND } from 'redux-first-router';
import { loadHomePage } from './state/modules/home/saga';
import {
  loadPlaceArTreasureDetailPage,
  loadPlaceArTreasurePage,
  editPlaceArTreasurePage,
  loadingPlaceArTreasureLanding,
} from './state/modules/placeArTreasure/saga';
import { loadProfilePage } from './state/modules/profile/saga';

import { loadBuyPointForHuntPage } from './state/modules/buyPointForHunt/saga';
import { loadCluePage } from './state/modules/clue/saga';
import { loadClueTenStepPage } from './state/modules/clueTenStep/saga';
import { loadMarketplacePage } from './state/modules/marketplace/saga';
import loadOTPVerification from './state/modules/otpVerification/sagas';
import loadResetPassword from './state/modules/resetPassword/sagas';
import {
  ROUTE_ABOUT_AND_CONTACT,
  ROUTE_AUTH_CALLBACK,
  ROUTE_BUY_POINT,
  ROUTE_CLUE_TEN_STEP,
  ROUTE_CLUES,
  ROUTE_CONNECT_XAMAN_CALLBACK,
  ROUTE_HOME,
  ROUTE_IGC_CRYPTO_PAGE,
  ROUTE_LOGIN,
  ROUTE_MARKET_PLACE,
  ROUTE_MARKETPLACE_EDIT_PROMOTION,
  ROUTE_MARKETPLACE_EDIT_PROMOTION_DETAIL,
  ROUTE_MY_PLACE_TREASURE,
  ROUTE_OTP_VERIFICATION,
  ROUTE_PLACE_AR_TREASURE,
  ROUTE_PLACE_AR_TREASURE_DETAIL,
  ROUTE_PLACE_AR_TREASURE_EDIT,
  ROUTE_PLACE_AR_TREASURE_LANDING,
  ROUTE_PLACE_GOLD,
  ROUTE_PLACE_PHYSICAL_QR_CODE,
  ROUTE_PLACE_QR_CODE,
  ROUTE_PLACE_QR_CODE_AND_GOLD_BAR,
  ROUTE_PROFILE,
  ROUTE_PROFILE_REFERRAL,
  ROUTE_RESET_PASSWORD,
  ROUTE_SIGNUP,
  ROUTE_BUY_POINT_TRANSFER_ETHEREUM,
  ROUTE_SWAP_POINT,
  ROUTE_SWAP_POINT_FOR_CRYPTO,
  ROUTE_TRANSACTION_MANAGEMENT,
  ROUTE_WISH_LIST,
  ROUTE_MOBILE_LANDING,
  ROUTE_PLANS,
  ROUTE_DELETE_ACCOUNT,
  ROUTE_MERCHANDISE,
  ROUTE_MERCHANDISE_DETAIL,
  ROUTE_TERMS_AND_CONDITIONS,
  ROUTE_PRIVACY_POLICY,
} from './state/modules/routing';
import { loadSwapPointForCryptoPage } from './state/modules/swapPointForCrypto/saga';
import { loadTransactionPage } from './state/modules/transaction/saga';
import { loadTreasureManagementPage } from './state/modules/treasureManagement/saga';
import { createRewardPage } from './state/modules/reward-items/saga';
import { loadPlansPage } from './state/modules/plans/saga';
import { loadMerchandisePage, loadProductDetailPage } from './state/modules/merchandise/saga';
import loadWishlistPage from './state/modules/wishlist/saga';

const routesMap = {
  [NOT_FOUND]: {
    path: '/not-found',
    component: 'NotFound',
  },
  [ROUTE_LOGIN]: {
    path: '/login',
    component: 'Login',
  },
  [ROUTE_SIGNUP]: {
    path: '/signup',
    component: 'Signup',
  },
  [ROUTE_TRANSACTION_MANAGEMENT]: {
    path: '/transactions',
    component: 'TransactionManagement',
    saga: loadTransactionPage,
    requiresAuth: true,
  },
  [ROUTE_MARKET_PLACE]: {
    path: '/marketplace',
    component: 'Marketplace',
    requiresAuth: true,
    saga: loadMarketplacePage,
  },
  [ROUTE_MARKETPLACE_EDIT_PROMOTION]: {
    path: '/marketplace/edit-promotion',
    component: 'MarketplaceEditPromotion',
    requiresAuth: true,
  },
  [ROUTE_MARKETPLACE_EDIT_PROMOTION_DETAIL]: {
    path: '/marketplace/edit-promotion/:id',
    component: 'MarketplaceEditPromotionDetail',
    requiresAuth: true,
  },
  [ROUTE_HOME]: {
    path: '/',
    component: 'Home',
    saga: loadHomePage,
    requiresAuth: true,
  },
  [ROUTE_PLACE_AR_TREASURE]: {
    path: '/place-ar-treasure',
    saga: loadPlaceArTreasurePage,
    component: 'PlaceArTreasure',
    requiresAuth: true,
  },
  [ROUTE_ABOUT_AND_CONTACT]: {
    path: '/about-and-contact',
    component: 'AboutAndContact',
    requiresAuth: false,
  },
  [ROUTE_PROFILE]: {
    path: '/profile',
    component: 'Profile',
    saga: loadProfilePage,
    requiresAuth: true,
  },
  [ROUTE_PROFILE_REFERRAL]: {
    path: '/profile/referral',
    component: 'ProfileReferral',
    requiresAuth: true,
  },
  [ROUTE_PLACE_AR_TREASURE_EDIT]: {
    path: '/place-ar-treasure/edit/:id',
    component: 'PlaceArTreasureEdit',
    requiresAuth: true,
    saga: editPlaceArTreasurePage,
  },
  [ROUTE_PLACE_AR_TREASURE_DETAIL]: {
    path: '/place-ar-treasure/:id',
    saga: loadPlaceArTreasureDetailPage,
    component: 'PlaceArTreasureDetail',
    requiresAuth: true,
  },
  [ROUTE_PLACE_AR_TREASURE_LANDING]: {
    path: '/place-ar-treasure/landing/:id',
    component: 'PlaceArTreasureLanding',
    saga: loadingPlaceArTreasureLanding,
    requiresAuth: false,
  },
  [ROUTE_MY_PLACE_TREASURE]: {
    path: '/my-place-treasure',
    saga: loadTreasureManagementPage,
    component: 'MyPlaceTreasure',
    requiresAuth: true,
  },
  [ROUTE_CLUES]: {
    path: '/clues',
    component: 'Clues',
    saga: loadCluePage,
    requiresAuth: false,
  },
  [ROUTE_CLUE_TEN_STEP]: {
    path: '/ten-step-hunt',
    component: 'ClueTenStepHunt',
    saga: loadClueTenStepPage,
    requiresAuth: false,
  },
  [ROUTE_BUY_POINT]: {
    path: '/buypointforhunt',
    component: 'BuyPointForHunt',
    requiresAuth: true,
    saga: loadBuyPointForHuntPage,
  },
  [ROUTE_BUY_POINT_TRANSFER_ETHEREUM]: {
    path: '/buypointforthunt/transfer/:slug',
    component: 'BuyPointForHuntTransferEthereum',
    // requiresAuth: true,
    // saga: loadBuyPointForHuntPage,
  },
  [ROUTE_PLACE_QR_CODE_AND_GOLD_BAR]: {
    path: '/place-qrcode-and-gold-bar',
    component: 'PlaceQRCodeAndGoldBar',
    requiresAuth: true,
  },
  [ROUTE_PLACE_QR_CODE]: {
    path: '/place-qrcode',
    component: 'PlaceQRCode',
    requiresAuth: true,
  },
  [ROUTE_PLACE_PHYSICAL_QR_CODE]: {
    path: '/place-physical-qrcode',
    component: 'PlacePhysicalQRCode',
    requiresAuth: true,
    saga: createRewardPage,
  },
  [ROUTE_SWAP_POINT]: {
    path: '/swap-point',
    component: 'SwapPoint',
    requiresAuth: true,
  },
  [ROUTE_SWAP_POINT_FOR_CRYPTO]: {
    path: '/easy-swap',
    component: 'SwapPointForCrypto',
    requiresAuth: true,
    saga: loadSwapPointForCryptoPage,
  },
  [ROUTE_IGC_CRYPTO_PAGE]: {
    path: '/igc-crypto/',
    component: 'IgcCrypto',
    requiresAuth: true,
  },
  [ROUTE_WISH_LIST]: {
    path: '/wish-list',
    component: 'WishList',
    requiresAuth: true,
    saga: loadWishlistPage,
  },
  [ROUTE_PLACE_GOLD]: {
    path: '/place-gold',
    component: 'PlaceGold',
    requiresAuth: true,
  },
  [ROUTE_AUTH_CALLBACK]: {
    path: '/callback-auth',
    component: 'AuthCallback',
  },

  [ROUTE_OTP_VERIFICATION]: {
    path: '/otp-verification',
    component: 'OTPVerification',
    saga: loadOTPVerification,
  },
  [ROUTE_RESET_PASSWORD]: {
    path: '/reset-password',
    component: 'ResetPassword',
    saga: loadResetPassword,
  },
  [ROUTE_CONNECT_XAMAN_CALLBACK]: {
    path: '/connect-xaman-callback',
    component: 'ConnectXamanCallback',
    saga: loadResetPassword,
  },
  [ROUTE_MOBILE_LANDING]: {
    path: '/mobile-landing',
    component: 'MobileLanding',
    requiresAuth: true,
  },
  [ROUTE_PLANS]: {
    path: '/plans',
    component: 'Plans',
    requiresAuth: true,
    saga: loadPlansPage,
  },
  [ROUTE_DELETE_ACCOUNT]: {
    path: '/delete-account',
    component: 'DeleteAccount',
    requiresAuth: false,
  },
  [ROUTE_MERCHANDISE]: {
    path: '/merchandise',
    component: 'Merchandise',
    requiresAuth: true,
    saga: loadMerchandisePage,
  },
  [ROUTE_MERCHANDISE_DETAIL]: {
    path: '/merchandise/:shopId/:productId',
    component: 'Merchandise/ProductDetail',
    requiresAuth: true,
    saga: loadProductDetailPage,
  },
  [ROUTE_TERMS_AND_CONDITIONS]: {
    path: '/terms-and-conditions',
    component: 'TermsAndConditions',
    requiresAuth: false,
  },
  [ROUTE_PRIVACY_POLICY]: {
    path: '/privacy-policy',
    component: 'PrivacyPolicy',
    requiresAuth: false,
  },
};

export default routesMap;
